import type { SVGProps } from 'react'
const SvgSyTimeSquare = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M7.666 2c-1.687 0-3.142.618-4.139 1.688S2 6.246 2 7.916v8.168c0 1.67.527 3.158 1.523 4.229S5.974 22 7.666 22h8.668c1.692 0 3.148-.617 4.145-1.687S22 17.753 22 16.084V7.916c0-1.67-.525-3.158-1.521-4.228C19.482 2.618 18.025 2 16.334 2zm0 1.5h8.668c1.338 0 2.343.453 3.047 1.209S20.5 6.559 20.5 7.916v8.168c0 1.358-.415 2.45-1.12 3.207-.703.756-1.707 1.209-3.046 1.209H7.666c-1.34 0-2.341-.453-3.045-1.209S3.5 17.441 3.5 16.084V7.916c0-1.357.418-2.45 1.123-3.207S6.333 3.5 7.666 3.5"
				clipRule="evenodd"
			/>
			<path
				d="M12 6.885a.75.75 0 0 0-.75.75v4.36a.75.75 0 0 0 .365.644l3.393 2.023a.75.75 0 0 0 1.027-.26.75.75 0 0 0-.26-1.029l-3.025-1.805V7.635a.75.75 0 0 0-.75-.75"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyTimeSquare
